import axios from 'axios';

// const baseUrl = process.env.REACT_APP_API_URL;
const baseUrl = process.env.REACT_APP_API_URL;

const axiosInstance = axios.create({
  baseURL: baseUrl,
});

axiosInstance.interceptors.request.use(
  config => {
    config.headers['x-access-token'] = process.env.REACT_APP_API_KEY;
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

export const getCaisse = async condition => {
  const response = await axiosInstance.get(`${baseUrl}/v1/finance/caisse`, {
    params: condition,
  });
  return response.data;
};

export const getRecapCaisses = async () => {
  const response = await axiosInstance.get(`${baseUrl}/v1/finance/caisse/recap`);
  return response.data;
};

export const getRecetteBoutique = async condition => {
  const response = await axiosInstance.get(`${baseUrl}/v1/finance/recette-magasin`, {
    params: condition,
  });
  return response.data;
};

export const getRecetteSession = async condition => {
  const response = await axiosInstance.get(`${baseUrl}/v1/finance/recette-session`, {
    params: condition,
  });
  return response.data;
};

export const getRecetteFinanceSession = async condition => {
  const response = await axiosInstance.get(`${baseUrl}/v1/finance/recette-session-finance`, {
    params: condition,
  });
  return response.data;
};

export const getRecetteTheoriqueSession = async condition => {
  const response = await axiosInstance.get(`${baseUrl}/v1/finance/recette-theorique-session`, {
    params: condition,
  });
  return response.data;
};

export const receptionnerRecette = async (condition, values) => {
  const response = await axiosInstance.post(`${baseUrl}/v1/finance/receptionner-recette`, {
    params: condition,
    data: values,
  });
  return response.data;
};

export const getEntetesSession = async condition => {
  const response = await axiosInstance.get(`${baseUrl}/v1/finance/entetes-session`, {
    params: condition,
  });
  return response.data;
};
